import React, { useEffect, useRef } from "react";
import "./VirasatMenuPage.scss"
import MenuCard from "../../components/MenuCard/MenuCard";
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";


const VirasatMenuPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const pages = useSelector((state) => state.companyData.pages)

    const page = pages.find((page) => page.PageId === "menu")

    const Components = page?.Components || []

    const containerRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatMenuPage-hero-header":
                return <div className="VirasatMenuPage-hero-header-cont">
                    <div className="VirasatMenuPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatMenuPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatMenuPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="VirasatMenuPage-hero-container">
                    <div className="VirasatMenuPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}
                    </div>
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatMenuPage-hero":
                return headerComponent(component)
            case "VirasatMenuPage-menus":
                return <div className="VirasatMenuPage-menucontainer">
                    {component?.Data?.map((value, key) => {
                        return (
                            <MenuCard menu={value} key={key} />
                        )
                    })}
                </div>
            case "VirasatMenuPage-menus-images":
                return <div className="band-carousel" ref={containerRef}>
                    <div className="band-content" ref={contentRef}>
                        {component?.Data?.map((data, index) => (
                            <img key={index} src={data?.src} alt={`img-${index}`} className="band-image" />
                        ))}
                    </div>
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatMenuPage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}

        </div>
    )
}
export default VirasatMenuPage